(function () {
    'use strict';

    angular
        .module('app')
        .controller('FooterController', FooterController);

    FooterController.$inject = ['$rootScope', '$cookies', 'localization', 'authenticator', '$scope', '$http'];

    function FooterController($rootScope, $cookies, localization, authenticator, $scope, $http) {
        var vm = this;
        vm.acceptCookies = acceptCookies;
        vm.isCookieAccepted = isCookieAccepted;
        vm.language = $cookies.get('selected_language');
        vm.accepted = $cookies.get('cookie_accepted');
        vm.setLanguage = setLanguage;
        vm.getLanguage = getLanguage;
        vm.setLocation = setLocation;
        vm.locationChanged = locationChanged;
        vm.show = true;
        vm.rootScope = $rootScope;
        vm.thisYear = new Date().getFullYear();
        vm.show_banner = false;

        vm.danish_cities = [
            'copenhagen',
            'odense',
            'aarhus',
            'randers',
            'esbjerg',
            'aalborg'
        ];
        vm.swedish_cities = [
            'stockholm',
            'goteborg',
            'malmo',
            'uppsala',
            'helsingborg'
        ];

        $rootScope.$on('$stateChangeStart', function () {
            vm.show = true;
        });

        vm.$onInit = function () {
            vm.show = true;
            vm.showLanguageSelect = false;
            authenticator.checkLoginStatus()
                .then(function (loggedIn) {
                    vm.loggedIn = loggedIn;
                });
            localization.getLocation().then(function (response) {
                vm.location = response;
                if(vm.location == "Denmark") {
                    vm.cities = vm.danish_cities;
                } else if(vm.location == "Sweden") {
                    vm.cities = vm.swedish_cities;
                }
            });
            // showBanner();
        };

        function isCookieAccepted() { //Checks whether the user has accepted the use of cookies
            vm.accepted = $cookies.get('cookie_accepted');
        }

        function acceptCookies() { //Sets a "cookie_accepted"-cookie
            var now = new Date();
            var expiration = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
            $cookies.put('cookie_accepted', true, { expires: expiration, path: '/' });
            vm.accepted = $cookies.get('cookie_accepted');
        }

        function showBanner(){
            $http.get('api/site_setting/1/is_active/')
            .then(function (response) {
                vm.show_banner = response.data.is_active;
            })
        }

        function getLanguage() {
            return localization.getLanguage();
        }
        /*
                function setLanguage($language) { //Sets the language cookie
                    localization.setLanguage($language);
                }
                 */
        function setLanguage($language) { //Sets the language cookie
            vm.language = $language;
            localization.setLanguage($language).then(function () {
                $scope.$applyAsync(function () {
                    vm.showLanguageSelect = false;
                    location.reload();
                });
            }).then(function() {
                if($language == 'sv') {
                    localization.setLocation('Sweden');
                }
                if($language == 'da_dk') {
                    localization.setLocation('Denmark');
                }
            });
        }

        function setLocation($location) { //Sets the language cookie
            vm.location = $location;
            localization.setLocation($location).then(function () {
                $scope.$applyAsync(function () {
                    vm.showLocationSelect = false;
                    location.reload();
                });
            });

        }

        function locationChanged() {
            location.reload();
        }
    }
})();
